module.exports = __webpack_public_path__ + "media/images/lb/035-e4df2f86c99333167e31fd7d718ed4ed.svg";